module.exports = __webpack_public_path__ + "static/04-protho-7b6889f694a3ca03256af6fe5c208975.jpg";